'use strict';

var React = require('react');
require('prop-types');
var instagramIcon = require('../../images/Onboarding/SocialMediaIcons/instagram-icon.js');
var facebookIcon = require('../../images/Onboarding/SocialMediaIcons/facebook-icon.js');
var twitterIcon = require('../../images/Onboarding/SocialMediaIcons/twitter-icon.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

function SocialMediaIconsSelection(_ref) {
  var socialMediaName = _ref.socialMediaName;

  switch (socialMediaName) {
    case 'facebook':
      return React__default["default"].createElement(facebookIcon, null);

    case 'twitter':
      return React__default["default"].createElement(twitterIcon, null);

    case 'instagram':
      return React__default["default"].createElement(instagramIcon, null);

    default:
      return null;
  }
}

module.exports = SocialMediaIconsSelection;
